export default __webpack_public_path__ + "device_onvif.09e40d48.png";